import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useEffect, useState } from 'react';
import { useOnceInView } from '@elem/compPage/on-the-road-power-solution/pages/product/components/US/useOnceInView';

interface ItfItem {
    name: string;
    text: string;
    img: string;
}
const F: React.FC = () => {
    const { t } = useLang('stream.overview');
    const [gap, setGap] = useState(20);
    const items: ItfItem[] = [
        {
            name: t('F_item1_name'),
            text: t('F_item1_text'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1774595206469/f1.jpg',
        },
        {
            name: t('F_item2_name'),
            text: t('F_item2_text'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1774595206505/f2.jpg',
        },
        {
            name: t('F_item3_name'),
            text: t('F_item3_text'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1774595206918/f3.jpg',
        },
    ];

    useOnceInView('.stream-nl-F .title', () => {
        document.querySelector('.stream-nl-F .title')?.classList.add('enter');
        document.querySelector('.stream-nl-F .desc')?.classList.add('enter');
        document.querySelector('.stream-nl-F .items')?.classList.add('enter');
    });

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth > 1440) setGap(24);
            if (window.innerWidth >= 1024) setGap(20);
            if (window.innerWidth < 1024) setGap(12);
        }
    }, []);

    return (
        <div className={`${css.section} stream-nl-F GtmModuleData-section space white`} id="stream-nl-F" data-section-id={'stream-nl-F'}>
            <div className="info">
                <h2 className="title ani-1">{t('F_title')}</h2>
                <p className="desc ani-2">{t('F_desc')}</p>
            </div>
            <Swiper slidesPerView={'auto'} spaceBetween={gap} className="items ani-3">
                {items?.map((item: ItfItem) => (
                    <SwiperSlide className="item" key={item.name}>
                        <EcoImg className="item-img" pc={item.img} alt={item.name} />
                        <div className="item-info">
                            <p className="item-name">{item.name}</p>
                            <p className="item-text">{item.text}</p>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default F;
